import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getObis',
})
export class GetObisPipe implements PipeTransform {
  transform(value: any) {
    if (!value) {
      return '';
    } else {
      const obis = value.obisId || value.obisCode;
      const splitObisId = obis.split(':')[1];
      return splitObisId || obis;
    }
  }
}
